export const messages = {
  en: {
    storeOrderCartFee: {
      queryTitle: 'Query Conditions',
      orderFeeTitle: 'Order Fee',
      feeNamePlaceholder: 'Please enter fee name',
      cartIdPlaceholder: 'Please enter cart ID',
      statePlaceholder: 'Please select status',
      cartId: 'Cart ID',
      feeName: 'Fee Name',
      price: 'Amount',
      payPrice: 'Payment Amount',
      payWayName: 'Payment Method',
      state: 'Status',
      updateTime: 'Payment Time',
      remark: 'Remark',
      unpaid: 'Unpaid',
      paid: 'Paid'
    }
  },
  zh: {
    storeOrderCartFee: {
      queryTitle: '查询条件',
      orderFeeTitle: '订单费用',
      feeNamePlaceholder: '请输入费用名称',
      cartIdPlaceholder: '请输入购物车ID',
      statePlaceholder: '请选择状态',
      cartId: '购物车ID',
      feeName: '费用名称',
      price: '金额',
      payPrice: '支付金额',
      payWayName: '支付方式',
      state: '状态',
      updateTime: '支付时间',
      remark: '备注',
      unpaid: '未支付',
      paid: '已支付'
    }
  }
}